export default __webpack_public_path__ + "static/media/Img245.d4ad1d02.jpg";